import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ILoadableDataProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<ILoadableDataProps>>
): IComponentSchema<ILoadableDataProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Loadable Data',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.LoadableData,
    'x-component-props': {
      visible: true,
      dataName: 'data',
      requestType: 'Custom',
      url: '',
    },
    'x-component-props-config': {},
  };
};
